import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-black rounded-md p-1 whitespace-nowrap",
  ref: "code"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("code", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ], 512 /* NEED_PATCH */))
}